<p-dialog appendTo="{{dialogTemplate.appendTo}}" styleClass="{{dialogTemplate.styleClass}}" class="modal" [showHeader]="dialogTemplate.isShowHeader" [header]="dialogTemplate.header" 
  [(visible)]="isDisplay" [modal]="dialogTemplate.isModal" 
  [breakpoints]="dialogTemplate.breakpoints" [style]="dialogTemplate.style"
  [dismissableMask]="dialogTemplate.isDismissableMask"
  (onHide)="closeModal()" [resizable]="dialogTemplate.isResizable"
  [closeOnEscape] = "dialogTemplate.closeOnEscape"
  [closable]="dialogTemplate.closable">
  <div class="modal-body">
    <ng-content select="[modal-body]"></ng-content>
  </div>
  <div *ngIf="dialogTemplate.hasBottom" class="modal-bottom">
    <ng-content select="[modal-bottom]"></ng-content>
  </div>
  <ng-template pTemplate="footer" *ngIf="dialogTemplate.hasFooter ?? false" >
    <ng-content select="[modal-footer]"></ng-content>
  </ng-template>
</p-dialog>
